const educationEn = [
  {
    degree: "Bachelor of Science — Concepteur de Systèmes d'Information (CSI)",
    institution: "3iL Ingénieurs (Limoges, France) • RNCP Level 6 (Bac+3)",
    period: "Nov 2019 - Dec 2021",
    description: "Accredited French degree (RNCP Level 6, Bac+3) in Information Systems Engineering, completed via the official international academic partnership with ETM Ibn Rochd. The curriculum focused on enterprise systems analysis and design (Merise, UML), relational database engineering (Oracle, SQL), Cisco networking and routing, Linux systems administration, and IT project lifecycle management.",
    skills: [
      "Information Systems Architecture",
      "Oracle Database & SQL",
      "Cisco Networking & Routing",
      "Linux Systems Administration",
      "Software Engineering Lifecycle",
      "IT Project Management"
    ],
  },
  {
    degree: "Diplôme d'Ingénieur Professionnel en Informatique — Concepteur de Systèmes d'Information",
    institution: "ETM IBN ROCHD (In partnership with 3iL Ingénieurs)",
    period: "Nov 2019 - Dec 2021",
    description: "Dual-degree engineering curriculum delivered in partnership with 3iL Ingénieurs France. Focused on enterprise software modeling, distributed architectures, database administration, network security, and translating complex business requirements into scalable, robust IT systems.",
    skills: [
      "Computer Science",
      "Relational Database Design",
      "Enterprise Systems Modeling",
      "Network Infrastructure & Security",
      "Data Governance"
    ],
  },
  {
    degree: "Professional Full-Stack Web Development Certification",
    institution: "Ecole De Communication et d'Informatique (ECI)",
    period: "2017 - 2018",
    description: "Intensive professional program dedicated to modern web engineering and dynamic application architectures. Covered full-stack client-server paradigms, RESTful API design, database connectivity, and production-ready web application development with modern frameworks.",
    skills: [
      "Full-Stack Web Development",
      "RESTful API Design",
      "Client-Server Architecture",
      "Modern JavaScript & PHP",
      "Responsive Web Design"
    ],
  },
  {
    degree: "University Studies in Physics & Applied Sciences",
    institution: "Université d'Alger (University of Algiers)",
    period: "2015 - 2017",
    description: "Foundational higher education in fundamental physics, calculus, thermodynamics, and mathematical analysis. Developed strong first-principles reasoning, computational modeling, and rigorous quantitative problem-solving skills applied to engineering.",
    skills: [
      "First-Principles Reasoning",
      "Mathematical Analysis & Calculus",
      "Applied Physics",
      "Analytical Modeling"
    ],
  },
  {
    degree: "Higher Technician Diploma (TS) — Computer Systems Networking & Telecommunications",
    institution: "Institut National Spécialisé de la Formation Professionnelle (INSFP)",
    period: "2014 - 2017",
    description: "National Higher Technician State Diploma (TS) covering practical computer systems engineering, network administration, telecommunications protocols, hardware diagnostics, and TCP/IP routing infrastructure.",
    skills: [
      "Network Administration (TCP/IP)",
      "Systems Diagnostics & Hardware",
      "Telecommunications Protocols",
      "Server Maintenance",
      "Operating Systems"
    ],
  },
];

export default educationEn;
